export const
  NOTIFICATION_DIALOGUE_SEQUENCES = {
    DEFEATED_BY_ATTACKER: 'DEFEATED_BY_ATTACKER',
    DEFEATED_BY_DEFENDER: 'DEFEATED_BY_DEFENDER',
    ATTACKER_VICTORY: 'ATTACKER_VICTORY',
    DEFENDER_VICTORY: 'DEFENDER_VICTORY',
  };